import { apiUri } from '../appConfig';

const themeList = () => (
	fetch(`${apiUri}/theme`)
		.then((res) => res.json())
		.catch((err) => console.error(err))
);

export default themeList;



// WEBPACK FOOTER //
// ./src/js/request/themeList.js